//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";
import TransitionExpand from "../../global/transitions/Expand";
import FilterItem from "./FilterItem";

export default {
  name: "SearchFilterGroup",
	props: {
		filter: Object,
		executeSearch: Function,
		setFilterValue: Function,
		setLoadingValue: Function,
	},
	components: {
		TransitionExpand,
		FilterItem
	},
	data() {
		return {
			dropdownActive: false,
			filterSearchQuery: "",
			dropdownMaxHeight: "none",
			userIsTyping: false,
			typingTimer: null,
			filterColumnThreshold: null
		}
	},
	computed: {
		// ...mapGetters([]),
		visibleFilterOptions() {
			// First return statement below needed when developing locally on FE since no way to add in visible:true property in filters data w/o building entirely new mirage mock server
			// Second return statement needed when deploying to any BE env

			// return this.filter.filters;
			return this.filter.filters.filter(f => f.visible);
		},
		isLongFilterList() {
			return this.visibleFilterOptions.length > this.filterColumnThreshold;
		},
		filterClasses() {
			return {
				dropdownActive: this.dropdownActive,
				'filters__filter--long': this.isLongFilterList
			}
		},
		noFilterItemsShowing() {
			return !this.visibleFilterOptions.some(f => f.value.toLowerCase().includes(this.filterSearchQuery.toLowerCase()));
		},
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		calcDropdownHeight() {
			if (!this.dropdownActive) {
				this.dropdownMaxHeight = "none";
				return;
			}
			const container = this.$el.querySelector(".filters__group-container");
			const top = container.getBoundingClientRect().top;
			const windowHeight = window.innerHeight;
			this.dropdownMaxHeight = `${windowHeight - top - 10}px`;
		},
		toggleDropdownActive() {
			this.dropdownActive = !this.dropdownActive;
			setTimeout(() => this.calcDropdownHeight(), 1);
		},
		updateFilterSearchQuery(e) {
			// set the value of the search query but only after the user has stopped typing for 500ms
			if (this.typingTimer) {
				clearTimeout(this.typingTimer);
				this.typingTimer = null;
			}
			this.typingTimer = setTimeout(() => {
				this.filterSearchQuery = e.target.value;
			}, 500);
		},
	},
	mounted() {
		this.filterColumnThreshold = !!this.options.filterColumnThreshold ? parseInt(this.options.filterColumnThreshold) : 45;
		
		document.body.addEventListener("click", e => {
			if (!this.$el.contains(e.target)) this.dropdownActive = false;
		});
		this.$el.addEventListener("blur", e => {
			if (!this.$el.matches("*:focus-within")) this.dropdownActive = false;
		});

		// Add scroll event listener to calculate dropdown height but throttle it to prevent performance issues
		let throttleTimer;
		window.addEventListener("scroll", () => {
			if (!throttleTimer) {
				throttleTimer = setTimeout(() => {
					throttleTimer = null;
					this.calcDropdownHeight();
				}, 100);
			}
		});

		document.body.addEventListener("keydown", e => {
			if (e.key === "Escape" && this.dropdownActive) this.toggleDropdownActive(); 
		});
	},
};
